import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  margin: 3.2rem 0;
`;

const BarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 7rem;

  position: sticky;
  bottom: 0;

  padding-top: 2rem;
  padding-bottom: 1rem;

  border-top: 0.1rem solid ${pickColor('gray')};

  background: ${pickColor('white')};
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: flex-end;

  position: absolute;
  right: 0;
  bottom: 1rem;
`;

const WarningContainer = styled.div``;

export { Container, ButtonWrapper, WarningContainer, BarContainer };
